import { EmailAddress } from './../models/dms/emailAddress.model';
import { ContactService } from 'app/services/contact.service';

import { catchError } from 'rxjs/operators';

import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { ToastController, AlertController, NavController } from '@ionic/angular';
import { UserService } from 'app/services/user.service';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';

import { FieldModel } from 'app/models/shared/field.model';
import { OpportunityActivityType, SecurityRight, VehicleClass } from 'app/utility/enums';
import { OpportunityActivityModel, OpportunityActivity_NoteModel, OpportunityActivity_IncomingSMSModel, OpportunityActivity_OutgoingSMSModel, OpportunityActivity_VehicleWantedModel, OpportunityActivity_IncomingEmailModel, OpportunityActivity_OutgoingEmailModel, OpportunityActivity_FollowUpModel, OpportunityActivity_FeedbackModel, OpportunityActivity_EnquiryModel, OpportunityActivity_PriceMyTradeModel, OpportunityActivity_TestDriveModel, DTOOpportunityActivity_BaseModel, OpportunityQuickResponseModel } from 'app/models/dms/opportunityActivity.model';
import { OpportunitySearchResultModel } from 'app/models/dms/opportunitySearchResult.model';
import { OpportunitySearchParamsModel } from 'app/models/dms/opportunitySearchParams.model';

import { Injectable } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError, Subscription, Subject } from 'rxjs';

import { Constants } from 'app/utility/constants';
import { OpportunityModel } from 'app/models/dms/opportunity.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { TabModel } from 'app/models/shared/tab.model';

import { LabelValueModel } from 'app/models/shared/labelValue.model';
import { LookupExternalModel } from 'app/models/shared/lookup.model';
import { DocumentModel } from 'app/models/dms/document.model';
import { SingleDocumentUploadModel } from 'app/models/shared/documentUpload.model';
import { OpportunitySaleCreateModel } from 'app/models/dms/opportunitySaleCreateModel';
import { DateHelper } from 'app/utility/datehelper';
import { CustomFieldDisplayModel } from 'app/models/shared/customField.model';
import { StringHelper } from 'app/utility/stringhelper';
import { OpportunityResultModel } from 'app/models/dms/opportunityResult.model';
import { PriceEditorModel } from 'app/models/shared/priceEditor.model';
import { OpportunityActivityResultModel } from 'app/models/dms/opportunityActivityResult.model';
import { OpportunityTransferModel } from 'app/models/dms/opportunityTransfer.model';

@Injectable({
	providedIn: 'root'
})
export class OpportunityService
{
    public opportunityMessage = new Subject<OpportunityModel>();

    constructor(
        private httpClient: HttpClient,
		private userService: UserService,
		private toastController: ToastController,
		private alertController: AlertController,
		private navCtrl: NavController,
		private contactService: ContactService
	)
	{
    }

    setupActivitiesFields(opportunity: OpportunityModel): any[]
    {
        let field_groups = [];
        let group = new FieldGroupModel(""); //opportunity.customer.displayName + " Activities");

        if (opportunity.activities && opportunity.activities.length)
        {
            for (let activity of opportunity.activities)
            {
                const startDay = DateHelper.getFormattedDate(activity.startDate);

                var activityDetails = new FieldModel(startDay, activity.activityTypeName);
                activityDetails.id = activity.id;
                activityDetails.sublabel = 'Staff: ' + activity.salesPersonCaption;
                activityDetails.subvalue = '' + (activity.vehicleStockNo ? activity.vehicleStockNo : "");
                activityDetails.detailObject = activity;
                activityDetails.classes = 'vehicle-activity-list-item';
                activityDetails.detail = true;
                group.addField(activityDetails);
            }
        }
        else
        {
            group.addField(new FieldModel("No activities", " "));
        }

        group.singleColumn = true;
        field_groups.push(group);

        return field_groups;
    }

	getOpportunities(searchParams: OpportunitySearchParamsModel): Observable<OpportunitySearchResultModel>
	{
		// console.log(searchParams);
		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient.get<OpportunitySearchResultModel>(Constants.ApiUrl + 'opportunities/search', { params: httpParams });
	}

	getOpportunitiesIndex(statusEnum: string, accountOwnerId: string, dealershipId: string): Observable<string[]>
	{
		let httpParams = new HttpParams();

		httpParams = httpParams.append('statusEnum', statusEnum);
		httpParams = httpParams.append('accountOwnerId', accountOwnerId);
		httpParams = httpParams.append('dealershipId', dealershipId);
		return this.httpClient.get<string[]>(Constants.ApiUrl + 'opportunities/index', { params: httpParams });
	}


	getOpportunityById(id: string, loadActivities: boolean = false): Observable<OpportunityModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('loadActivities', loadActivities ? "true" : "false");
		return this.httpClient.get<OpportunityModel>(Constants.ApiUrl + 'Opportunities/' + id, { params: httpParams })
	}

	saveOpportunity(o: OpportunityModel): Observable<OpportunityModel>
	{
		// console.log(o);
		if (o.id == Constants.EmptyGuid)
		{
			return this.httpClient.post<OpportunityModel>(Constants.ApiUrl + 'Opportunities/new', o);
		}
		else
		{
			return this.httpClient.put<OpportunityModel>(Constants.ApiUrl + 'Opportunities/' + o.id, o);
		}
	}


	errorHandler(error: any): void
	{
		console.error(error);
		var dtoError: any;
		if (error.error && error.error.entityDataJson)
		{
			dtoError = JSON.parse(error.error.entityDataJson);
		}

		var statusCode = 500;
		if (dtoError && dtoError.Message != null)
		{
			//api error
			var errorMessage = dtoError.Message;
			var showAlert = true;
			var errorTitle: string = "";
			statusCode = dtoError.StatusCode;

			switch (statusCode)
			{
				case 404:
					errorTitle = "Not Found Error";
					break;
				case 400:
					errorTitle = "Validation Error";
					break;
				case 401:
					errorTitle = "Login Error"; //we shouldn't get this
					this.navCtrl.navigateRoot('/login');
					break;
				case 403:
					errorTitle = "Security Error";
					break;
				default:
					errorTitle = "Error";
					break;
			}

			this.presentAlert(errorTitle, errorMessage);
		}

		if (error.status == 504)
		{
			this.presentAlert("Server Error", 'Unable to receive a timely response from the server.');
		}
		if (error.status == 500)
		{
			this.presentAlert("Server Error", 'An error occurred on the server. Please contact our support team if this error continues.');
		}
		if (error.status == 404)
		{
			this.presentAlert("Not Found Error", 'This resource was not found. Please contact our support team if this error continues.');
		}
		if (error.status == 403)
		{
			this.presentAlert("Security Error", 'This resource was not found. Please contact our support team if this error continues.');
		}
	}

	async showToastAlert(message: string, color: string = "danger")
	{
		this.userService.presentToast(message, color);
	}

	async presentAlert(title, message)
	{
		this.userService.presentAlert(title, message);
	}


	patchOpportunity(o: OpportunityModel, action: string): Observable<OpportunityModel>
	{
		// console.log(o);
		switch (action)
		{
			case "next-action":
				return this.httpClient.patch<OpportunityModel>(Constants.ApiUrl + 'Opportunities/' + o.id + '/NextAction', o);
				break;
			case "first-contact":
				return this.httpClient.patch<OpportunityModel>(Constants.ApiUrl + 'Opportunities/' + o.id + '/FirstContact', o);
				break;
			case "status":
			default:
				return this.httpClient.patch<OpportunityModel>(Constants.ApiUrl + 'Opportunities/' + o.id + '/Status', o);
		}
	}

	getOpportunityActivityTemplate(opportunityId: string, vehicleId: string, customerId: string, activityType: OpportunityActivityType)
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('opportunityId', opportunityId ? opportunityId : Constants.EmptyGuid);
		httpParams = httpParams.append('vehicleId', vehicleId ? vehicleId : Constants.EmptyGuid);
		httpParams = httpParams.append('customerId', customerId ? customerId : Constants.EmptyGuid);
		httpParams = httpParams.append('activityType', activityType);

		return this.httpClient.get<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/new', { params: httpParams });
	}

	getOpportunityActivity(id: string)
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/' + id, { params: httpParams });
	}

	saveOpportunityActivity(oa: OpportunityActivityModel): Observable<OpportunityActivityModel>
	{
		// console.log("Save opportunity activity", oa);
		if (oa.id == Constants.EmptyGuid)
		{
			return this.httpClient.post<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/new', oa);
		}
		else
		{
			return this.httpClient.put<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/' + oa.id, oa);
		}
	}

	submitToFinanceProvider(id: string, dealerLed: boolean): Observable<OpportunityActivityModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('dealerLed', dealerLed ? "true" : "false");
		return this.httpClient.patch<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/' + id + '/SubmitToFinanceProvider', httpParams);
	}

	requestDigitalSigning(id: string): Observable<OpportunityActivityModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.patch<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/' + id + '/RequestDigitalSigningForActivity', httpParams);
	}

	revokeDigitalSigning(id: string, cancellationReason: string): Observable<OpportunityActivityModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('cancellationReason', cancellationReason);
		return this.httpClient.patch<OpportunityActivityModel>(Constants.ApiUrl + 'Activities/' + id + '/RevokeDigitalSigningForActivity', httpParams);
	}

	async uploadOpportunityActivityFiles(loading: any, oa: OpportunityActivityModel, fields: FieldModel[], success: string[] = [])
	{
		var fieldSuccessful: FieldModel[] = [];

		var field = fields.pop();
		var prefixed = true;

		var base64 = (prefixed ? "" : "data:image/png;base64,") + field.value;
		var url = base64;
		let blob = await fetch(url).then(r => r.blob());
	}

	uploadFileToUrl(url: string, blob: Blob): Observable<any>
	{
		const formData = new FormData();
		formData.append('image', blob);
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' }).pipe(
			catchError(this.handleError));
	}

	private handleError(error: any)
	{
		let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		return throwError(error);
	}

	/**
	 * Converts data uri to Blob. Necessary for uploading.
	 * @see
	 *   http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
	 * @param  {String} dataURI
	 * @return {Blob}
	 */
	public base64toBlob(byteString)
	{
        return StringHelper.base64toBlob(byteString); //convert base64/URLEncoded data component to raw binary data held in a string
    }

	public fieldGroupTabs: TabModel[];
	listUsers: ListItemModel[];
	public setupFieldGroups(opportunity: OpportunityModel, editOpportunity: OpportunityModel, listUsers: ListItemModel[], editActive: boolean, makeDirty: boolean = false, disableClone: boolean = false): TabModel[]
	{
		this.fieldGroupTabs = [];
		this.fieldGroupTabs = [];
		this.listUsers = listUsers;
		if (this.userService.hasUserRight(SecurityRight.OpportTabsOpportunityGeneralView))
		{
			this.fieldGroupTabs.push(new TabModel("General", opportunity, this.getFieldGroups(editOpportunity, editActive, "General"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
			// fieldGroupTabs.push(new TabModel("Referral", opportunity, this.getFieldGroups(editOpportunity, editActive, "Referral"), makeDirty, "referral", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
			// fieldGroupTabs.push(new TabModel("Next action", opportunity, this.getFieldGroups(editOpportunity, editActive, "Next action"), makeDirty, "next action", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
			this.fieldGroupTabs.push(new TabModel("Status", opportunity, this.getFieldGroups(editOpportunity, editActive, "Status"), makeDirty, "status", "", this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralView), this.userService.hasUserRight(SecurityRight.OpportTabsFinanceAppGeneralEdit)));
		}

		if (this.userService.mcMinVersion("3.2.20") && this.userService.hasUserRight(SecurityRight.OpportTabsOpportunityCustomView))
		{
			this.fieldGroupTabs.push(new TabModel("Custom", opportunity, this.getFieldGroups(editOpportunity, editActive, "Custom"), makeDirty, "custom", "", this.userService.hasUserRight(SecurityRight.OpportTabsOpportunityCustomView), this.userService.hasUserRight(SecurityRight.OpportTabsOpportunityCustomEdit)));
		}

		return this.fieldGroupTabs;
	}

	public getFieldGroups(editOpportunity: OpportunityModel, editActive: boolean, groupId: string): FieldGroupModel[]
	{
		editOpportunity = editOpportunity;
		var field_groups = [];
		var group: FieldGroupModel;
		switch (groupId)
		{
			case "General":
				group = new FieldGroupModel("Basic Details");
				group.addField(new FieldModel("Opportunity No.", editOpportunity.opportNo, "text", "opportNo", false, false, null, null, null, true));
				group.addField(new FieldModel('Customer', editOpportunity.customerId, 'contact', 'contactId', false, false, editOpportunity.customer));
				group.addField(new FieldModel('Description', editOpportunity.description, 'text', 'description', true, false));
				group.addField(new FieldModel("Open Date", editOpportunity.openDate, "date", "openDate", true, false));
				group.addField(new FieldModel('Dealership', editOpportunity.dealershipId, 'contact', 'companyId', true, false, editOpportunity.dealership));
				if (editActive)
				{
					group.addField(new FieldModel('Owner', editOpportunity.salesPersonId, 'select', 'salesPersonId', true, false, this.listUsers));
				}
				else
				{
					group.addField(new FieldModel('Owner', editOpportunity.salesPersonId, 'contact', 'salesPersonId', false, false, editOpportunity.salesPerson));
				}
				field_groups.push(group);
				group = new FieldGroupModel("First Contact");
				group.addField(new FieldModel("Medium", editOpportunity.originEnum, "lookup", "originEnum", true, true, editOpportunity.origin));
				group.addField(new FieldModel("Referrer", editOpportunity.referralMethodId, "lookup", "referralMethodId", true, true, editOpportunity.referralMethod));
				if (this.userService.mcMinVersion("3.2.18")) group.addField(new FieldModel("Campaign", editOpportunity.campaignId, "lookup", "campaignId", true, false, editOpportunity.campaign));
				field_groups.push(group);
				break;
			case "Next action":
				break;
			case "Status":
				group = new FieldGroupModel("Next action");
				group.addField(new FieldModel("Next action", editOpportunity.nextActId, "lookup", "nextActId", true, true, editOpportunity.nextAct));
				group.addField(new FieldModel("Next action date", editOpportunity.nextActDate, "date", "nextActDate", true, true));
				field_groups.push(group);

				group = new FieldGroupModel("Status Details");
				var status = new FieldModel("Status", editOpportunity.statusEnum, "lookup", "statusEnum", true, true, editOpportunity.status)
				status.exclude = ["-1"];
				status.hasChildren = true;
				group.addField(status);

				var reasonOpen = new FieldModel("Assignee", editOpportunity.reasonOpenId, "lookup", "reasonOpenId", true, false, editOpportunity.reasonOpen);
				reasonOpen.parent = 'statusEnum';
				reasonOpen.preventParentIdInLookup = true;
				reasonOpen.toggleEditableWhen = "0";
				reasonOpen.editable = (editOpportunity.statusEnum.toString() + "" == "0");
				if (editActive || reasonOpen.editable) group.addField(reasonOpen);

				var reasonWon = new FieldModel("Reason Won", editOpportunity.reasonWonId, "lookup", "reasonWonId", true, false, editOpportunity.reasonWon);
				reasonWon.parent = 'statusEnum';
				reasonWon.preventParentIdInLookup = true;
				reasonWon.toggleEditableWhen = "10";
				reasonWon.editable = (editOpportunity.statusEnum.toString() + "" == "10");
				if (editActive || reasonWon.editable) group.addField(reasonWon);

				var reasonLost = new FieldModel("Reason Lost", editOpportunity.reasonLostId, "lookup", "reasonLostId", true, false, editOpportunity.reasonLost);
				reasonLost.parent = 'statusEnum';
				reasonLost.preventParentIdInLookup = true;
				reasonLost.toggleEditableWhen = "20";
				reasonLost.editable = (editOpportunity.statusEnum.toString() + "" == "20");
				if (editActive || reasonLost.editable) group.addField(reasonLost);

				group.addField(new FieldModel('Comments', editOpportunity.comment, 'text', 'comments', true, false));
				if (editActive)
				{
					group.addField(new FieldModel('Estimated Value', editOpportunity.estValue, 'currency', 'estValue', true, false));
				}
				else
				{
					group.addField(new FieldModel('Estimated Value', editOpportunity.estValue, 'currency', 'estValue', true, false));
				}
				group.addField(new FieldModel("Probability", editOpportunity.probabilityEnum, "lookup", "probabilityEnum", true, true, editOpportunity.probability));
				field_groups.push(group);

				break;
			case "Custom":
				group = new FieldGroupModel("Custom Fields");
				group.singleColumn = true;
				for (let i = 1; i <= 6; i++) {
					const customFieldDisplayModel = CustomFieldDisplayModel.fromDto(editOpportunity[`customField${i}_Object`]);
					if (!customFieldDisplayModel) continue;
					if (customFieldDisplayModel.visible)
					{
						const customFieldValue = editOpportunity[`customField${i}`];
						group.addField(new FieldModel(customFieldDisplayModel.name, customFieldValue, customFieldDisplayModel.fieldModelType, `customField${i}`, true, false, customFieldDisplayModel.dropdownOptions));
					}
				}
				field_groups.push(group);
				break;
		}
		return field_groups;
	}


	public numberWithCommas(x: any): string
	{
		return StringHelper.numberWithCommas(x);
	}


	public scanLicence(blob: Blob): Observable<any>
	{
		const formData = new FormData();
		formData.append('image', blob);
		let url = Constants.ApiUrl + 'Activities/DriverLicenceOcr';
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });
	}

	editOpportunityActivity: OpportunityActivityModel;
	editActive: boolean = false;
	public getFieldGroupsForActivity(editOpportunityActivity: OpportunityActivityModel,
		editActive: boolean,
		groupId: "general" |
			"Note" |
			"Feedback" |
			"Enquiry" |
			"FollowUp" |
			"TestDrive" |
			"TestDriveLicence" |
			"TestDriveTerms" |
            "LoanVehicle" |
            "LoanVehicleLicence" |
            "LoanVehicleTerms" |
			"PriceMyTrade" |
			"PriceMyTradeValuation" |
			"PriceMyTradeImages" |
			"VehicleWanted" |
			"OutgoingEmail" |
			"IncomingEmail" |
			"OutgoingSMS" |
			"IncomingSMS" |
			"FinanceApp" |
            "Sale" |
            "Quote",
        isExpress: boolean,
		includeGeneral: boolean = true): FieldGroupModel[]
	{
		this.editOpportunityActivity = editOpportunityActivity;
		this.editActive = editActive;
		var field_groups = [];
		var group: FieldGroupModel;

		// if (groupId != "General" && includeGeneral)
		// {
		// 	field_groups = this.getFieldGroups("General");
		// }
		switch (groupId)
		{
			case "general":
				if (this.editOpportunityActivity.opportunityId == Constants.EmptyGuid)
				{
					group = new FieldGroupModel("Opportunity details");
					group.addField(new FieldModel("Referrer", this.editOpportunityActivity.referralMethodId, "lookup", "referralMethodId", true, true, this.editOpportunityActivity.referralMethod));
					if (this.userService.mcMinVersion("3.2.18")) group.addField(new FieldModel("Campaign", this.editOpportunityActivity.campaignId, "lookup", "campaignId", true, false, this.editOpportunityActivity.campaign));
					group.addField(new FieldModel("Dealership", this.editOpportunityActivity.dealershipId, "contact", "dealershipId", true, false, this.editOpportunityActivity.dealership));
					group.addField(new FieldModel("Salesperson", this.editOpportunityActivity.salesPersonId, "contact", "salesPersonId", true, false, this.editOpportunityActivity.salesPerson));
					group.addField(new FieldModel("Customer", this.editOpportunityActivity.customerId, "contact", "customerId", true, true, this.editOpportunityActivity.customer, null, null, true));
					field_groups.push(group);
				}
				else
				{
					group = new FieldGroupModel("Customer details");

					group.addField(new FieldModel("Referrer", this.editOpportunityActivity.referralMethodId, "lookup", "referralMethodId", true, false, this.editOpportunityActivity.referralMethod));

					if (this.userService.mcMinVersion("3.2.18")) group.addField(new FieldModel("Campaign", this.editOpportunityActivity.campaignId, "lookup", "campaignId", true, false, this.editOpportunityActivity.campaign));

					group.addField(new FieldModel("Customer", this.editOpportunityActivity.customerId, "contact", "customerId", false, false, this.editOpportunityActivity.customer, null, null, true));

					if (this.editOpportunityActivity.customer.mobile)
					{
						group.addField(new FieldModel("Mobile", this.editOpportunityActivity.customer.mobile, "text", "customerMobile", false, false, this.editOpportunityActivity.customer.mobile, null, null, true));
					}
					if (this.editOpportunityActivity.customer.primaryEmail)
					{
						group.addField(new FieldModel("Email", this.editOpportunityActivity.customer.primaryEmail, "email", "primaryEmail", false, false, this.editOpportunityActivity.customer.primaryEmail, null, null, true));
					}
					field_groups.push(group);
				}

				group = new FieldGroupModel("Related vehicle");
				group.addField(new FieldModel("Vehicle", this.editOpportunityActivity.vehicleId, "vehicle", "vehicleId", true, false, this.editOpportunityActivity.vehicle, null, null, true));
				field_groups.push(group);
				break;


			case OpportunityActivityType.Note:
				group = new FieldGroupModel("Note details");
				group.addField(new FieldModel("Date & time", this.editOpportunityActivity.note.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("Subject", this.editOpportunityActivity.note.subject, "text", "subject", true, true));
				group.addField(new FieldModel("Body", this.editOpportunityActivity.note.body, "longtext", "body", true, true));
				field_groups.push(group);
				break;
			case OpportunityActivityType.Feedback:
				group = new FieldGroupModel("Feedback details");
				group.addField(new FieldModel("Date & time", this.editOpportunityActivity.feedback.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("Feedback", this.editOpportunityActivity.feedback.feedback, "longtext", "feedback", true, true));
				group.addField(new FieldModel("Comments", this.editOpportunityActivity.feedback.comment, "longtext", "comment", true, true));
				field_groups.push(group);
				break;
			case OpportunityActivityType.Enquiry:
				group = new FieldGroupModel("Enquiry details");
				group.addField(new FieldModel("Date & time", this.editOpportunityActivity.enquiry.startDate, "datetime", "startDate", true, true));
				if (this.editOpportunityActivity.enquiry.contentType == "text/html")
				{
					var preview = this.editOpportunityActivity.enquiry.enquiryPreview.substr(0, 75) + (this.editOpportunityActivity.enquiry.enquiryPreview.length > 75 ? "..." : "");
					// group.addField(new FieldModel("Enquiry Preview", preview , "longtext", "enquiry", true, false));

					group.addField(new FieldModel("Enquiry", preview, "iframe", "iframe", false, false, " ", ""));
				}
				else
				{
					group.addField(new FieldModel("Enquiry", this.editOpportunityActivity.enquiry.enquiry, "longtext", "enquiry", true, false));
				}
				group.addField(new FieldModel("Comments", this.editOpportunityActivity.enquiry.comment, "longtext", "comment", true, false));

				field_groups.push(group);
				break;
			case OpportunityActivityType.FollowUp:
				group = new FieldGroupModel("Follow-Up details");
				group.addField(new FieldModel("Date & time", this.editOpportunityActivity.followUp.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("Comments", this.editOpportunityActivity.followUp.comment, "longtext", "comment", true, true));
				field_groups.push(group);
				break;
			case OpportunityActivityType.TestDrive:
				group = new FieldGroupModel("Test drive Details");
				group.addField(new FieldModel("Start date & time", this.editOpportunityActivity.testDrive.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("End date & time", this.editOpportunityActivity.testDrive.endDate, "datetime", "endDate", true, true));
				group.addField(new FieldModel("Comments", this.editOpportunityActivity.testDrive.comment, "longtext", "comment", true, false));

				if (this.userService.mcMinVersion("3.2.9"))
				{
					group.addField(new FieldModel("Accompanied by salesperson", this.editOpportunityActivity.testDrive.testDriveAccompanied, 'toggle', 'testDriveAccompanied', true, false));
				}

				if (this.editOpportunityActivity.id != Constants.EmptyGuid)
				{
					group.addField(new FieldModel('Test drive complete & vehicle returned', this.editOpportunityActivity.testDrive.testDriveComplete, 'toggle', 'testDriveComplete', true, false, null));
					var testDriveCompleteTimestamp = this.getFormattedDateTime(this.editOpportunityActivity.testDrive.testDriveCompleteTimestamp);

					if (this.editOpportunityActivity.testDrive.testDriveComplete && testDriveCompleteTimestamp)
					{
						group.addField(new FieldModel("Test drive completed time", testDriveCompleteTimestamp, "text", "testDriveCompleteTimestamp", false, false, null, null, null, true));
					}
				}
				if (this.userService.mcMinVersion("3.2.19"))
				{
					var dealerPlateLookup = new FieldModel("Dealer Plate", this.editOpportunityActivity.testDrive.testDriveDealerPlateId, "lookup", "testDriveDealerPlateId", true, false, this.editOpportunityActivity.testDrive.testDriveDealerPlate);
                    dealerPlateLookup.allowClear = true;
                    group.addField(dealerPlateLookup);
				}
				field_groups.push(group);
				break;
			case "TestDriveLicence":
				group = new FieldGroupModel("Driver licence");
				var resourceUrl = (this.editOpportunityActivity.testDrive.driverLicenceImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/TestDriveDriverLicence?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image = new FieldModel("Driver licence front", resourceUrl, "photo", "TestDriveDriverLicence", true, false);
				group.addField(image);

				var resourceUrl2 = (this.editOpportunityActivity.testDrive.driverLicenceBackImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/TestDriveDriverLicenceBack?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image2 = new FieldModel("Driver licence back", resourceUrl2, "photo", "TestDriveDriverLicenceBack", true, false);
				group.addField(image2);
				field_groups.push(group);
				break;
			case "TestDriveTerms":
				if (this.editOpportunityActivity.signingRequest)
				{
					group = new FieldGroupModel("Terms agreement");
					var status = new FieldModel("Digital signing status", this.editOpportunityActivity.signingRequest.workflowStatus, "inlinehtml", "workflowStatus", false, false);
					// status.sublabel = "Manage digital signing in the ⋮ menu.";
					// status.subvalue = " ";
					group.addField(status);
					var details = this.editOpportunityActivity.signingRequest.description.replace(";", "<br/>").replace("Resent", "Resent:").replace("Sent", "Sent:");
					details += `<br/><br/>To: ${this.editOpportunityActivity.signingRequest.recipientContact.displayName} &lt;${this.editOpportunityActivity.signingRequest.recipientContact.primaryEmail}&gt;`;
					details += `<br/>From: ${this.editOpportunityActivity.signingRequest.senderContact.displayName} (${this.editOpportunityActivity.signingRequest.senderCompany.displayName}) &lt;${this.editOpportunityActivity.signingRequest.senderCompany.primaryEmail}&gt;`;
					group.addField(new FieldModel("Details", details, "inlinehtml", "caption", false, false));

					field_groups.push(group);
				}
				else
				{
					group = new FieldGroupModel("Terms agreement");
					if (this.editOpportunityActivity.customer && this.editOpportunityActivity.customer.id != Constants.EmptyGuid)
					{
						// console.log(this.editOpportunityActivity.customer);
						this.editOpportunityActivity.testDrive.testDriveTerms = this.editOpportunityActivity.testDrive.testDriveTerms.replace("{{CustomerName}}", this.editOpportunityActivity.customer.displayName);
					}

					// this.editOpportunityActivity.testDrive.testDriveTerms.replace("{{CustomerName}}", this.editOpportunityActivity.salesPerson.de;
                    if (!isExpress)
                    {
					    group.addField(new FieldModel("Terms", "" + this.editOpportunityActivity.testDrive.testDriveTerms + "", "inlinehtml", "testDriveTerms", false, false, null, null, null, true));

					    group.addField(new FieldModel("Yes, I agree to these terms", this.editOpportunityActivity.testDrive.acceptTerms, "toggle", "acceptTerms", true, false));
                    }
					var resourceUrl = (this.editOpportunityActivity.testDrive.signatureImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/TestDriveSignature" : "";
					var signature = new FieldModel("Test drive signature", resourceUrl, "signature", "TestDriveSignature", true, false);
					signature.showPlaceholder = (!this.editOpportunityActivity.testDrive.signatureImageExists);
					// console.log(this.editOpportunityActivity.testDrive.signatureImageExists, signature.showPlaceholder );
					group.addField(signature);

					if (this.userService.mcMinVersion("3.1.33") && this.editOpportunityActivity.testDrive.testDriveSignatureName)
					{
						var signedBy = new FieldModel("Signed By name", this.editOpportunityActivity.testDrive.testDriveSignatureName, "text", "testDriveSignatureName", true, false);
						group.addField(signedBy);
						group.addField(new FieldModel("Signed By date", this.editOpportunityActivity.testDrive.testDriveSignatureTimestamp, "datetime", "subject", false, false));
					}

					// group.addField(new FieldModel("Signed By Date", this.editOpportunityActivity.testDrive.TestDriveSignatureTimestamp, "date", "subject", false, false, null, null, '', true));
					field_groups.push(group);
				}
				break;

			case OpportunityActivityType.PriceMyTrade:
				group = new FieldGroupModel("Vehicle details");
				group.addField(new FieldModel("Reg plate no.", this.editOpportunityActivity.priceMyTrade.priceMyTradeRegNo ? this.editOpportunityActivity.priceMyTrade.priceMyTradeRegNo : "", "text", "priceMyTradeRegNo", true, false));
				group.addField(new FieldModel("VIN", this.editOpportunityActivity.priceMyTrade.priceMyTradeVin, "text", "priceMyTradeVin", true, false));
				group.addField(new FieldModel("Year", this.editOpportunityActivity.priceMyTrade.priceMyTradeYear ? this.editOpportunityActivity.priceMyTrade.priceMyTradeYear : "", "number", "priceMyTradeYear", true, true));
				group.addField(new FieldModel("Make", this.editOpportunityActivity.priceMyTrade.priceMyTradeMake, "text", "priceMyTradeMake", true, true));
				group.addField(new FieldModel("Model", this.editOpportunityActivity.priceMyTrade.priceMyTradeModel, "text", "priceMyTradeModel", true, true));
				group.addField(new FieldModel("Variant", this.editOpportunityActivity.priceMyTrade.priceMyTradeVariant, "text", "priceMyTradeVariant", true, false));
				group.addField(new FieldModel("Odometer (km)", this.editOpportunityActivity.priceMyTrade.priceMyTradeOdometer ? this.editOpportunityActivity.priceMyTrade.priceMyTradeOdometer : "", "number", "priceMyTradeOdometer", true, false));
				group.addField(new FieldModel("Transmission", this.editOpportunityActivity.priceMyTrade.priceMyTradeTransmission, "text", "priceMyTradeTransmission", true, false));
				group.addField(new FieldModel("Fuel type", this.editOpportunityActivity.priceMyTrade.priceMyTradeFuelType, "text", "priceMyTradeFuelType", true, false));
				group.addField(new FieldModel("Engine size from (cc)", this.editOpportunityActivity.priceMyTrade.priceMyTradeEngineSize ? this.editOpportunityActivity.priceMyTrade.priceMyTradeEngineSize : "", "number", "priceMyTradeEngineSize", true, false));
				group.addField(new FieldModel("Colour", this.editOpportunityActivity.priceMyTrade.priceMyTradeExtColor, "text", "priceMyTradeExtColor", true, false));
				group.addField(new FieldModel('Features', this.editOpportunityActivity.priceMyTrade.priceMyTradeFeatureIds, 'lookups', 'priceMyTradeFeatureIds', true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeFeatureLookups, '', VehicleClass.PassengerVehicle));
				field_groups.push(group);
				group = new FieldGroupModel("Licensing");
				group.addField(new FieldModel("Registration expiry", this.editOpportunityActivity.priceMyTrade.priceMyTradeLicenceExpiryDate, "date", "priceMyTradeLicenceExpiryDate", true, false));
				group.addField(new FieldModel("WOF/COF expiry", this.editOpportunityActivity.priceMyTrade.priceMyTradeWofExpiryDate, "date", "priceMyTradeWofExpiryDate", true, false));
				field_groups.push(group);


				group = new FieldGroupModel("Seller information");
				group.addField(new FieldModel("Comments/Feedback", this.editOpportunityActivity.priceMyTrade.priceMyTradeSellerComment, "longtext", "priceMyTradeSellerComment", true, false));
				group.addField(new FieldModel("Last serviced", this.editOpportunityActivity.priceMyTrade.priceMyTradeLastService, "date", "priceMyTradeLastService", true, false));

				field_groups.push(group);


				break;
			case "PriceMyTradeValuation":

				group = new FieldGroupModel("Appraisal Details");
				if (this.editOpportunityActivity.opportunityId != Constants.EmptyGuid)
				{
					group.addField(new FieldModel("Date & Time", this.editOpportunityActivity.priceMyTrade.startDate, "datetime", "startDate", true, true));
				}
				if (this.checkMcMinVersion("3.1.33"))
				{
					group.addField(new FieldModel("Appraised By", this.editOpportunityActivity.priceMyTrade.priceMyTradeAppraisedById, "contact", "priceMyTradeAppraisedById", true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeAppraisedBy));
				}
				field_groups.push(group);

				if (this.checkMcMinVersion("3.1.33"))
				{
					group = new FieldGroupModel("Initial estimate");
					var initialEstimate = new FieldModel("Initial estimate ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeInitialEstimate ? this.editOpportunityActivity.priceMyTrade.priceMyTradeInitialEstimate : "", "currency", "priceMyTradeInitialEstimate", true, false);
					initialEstimate.hasChildren = true;
					group.addField(initialEstimate);
					field_groups.push(group);

					group = new FieldGroupModel("Vehicle condition");
					group.addField(new FieldModel("Exterior condition", this.editOpportunityActivity.priceMyTrade.priceMyTradeExteriorConditionEnum, "lookup", "priceMyTradeExteriorConditionEnum", true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeExteriorCondition));
					group.addField(new FieldModel("Interior condition", this.editOpportunityActivity.priceMyTrade.priceMyTradeInteriorConditionEnum, "lookup", "priceMyTradeInteriorConditionEnum", true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeInteriorCondition));
					group.addField(new FieldModel("Tyre condition", this.editOpportunityActivity.priceMyTrade.priceMyTradeTyresConditionEnum, "lookup", "priceMyTradeTyresConditionEnum", true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeTyresCondition));
					group.addField(new FieldModel('Alerts/Issues', this.editOpportunityActivity.priceMyTrade.priceMyTradeIssueIds, 'lookups', 'priceMyTradeIssueIds', true, false, this.editOpportunityActivity.priceMyTrade.priceMyTradeIssueLookups, '', VehicleClass.None));
					field_groups.push(group);

					group = new FieldGroupModel("Reconditioning estimates");
					var paintpanel = new FieldModel("Paint & Panel ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostPaintAndPanel ? this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostPaintAndPanel : "", "currency", "priceMyTradeReconditioningCostPaintAndPanel", true, false);
					paintpanel.hasChildren = true;
					group.addField(paintpanel);
					var mechanical = new FieldModel("Mechanical ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostMechanical ? this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostMechanical : "", "currency", "priceMyTradeReconditioningCostMechanical", true, false);
					mechanical.hasChildren = true;
					group.addField(mechanical);
					var electrical = new FieldModel("Electrical ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostElectrical ? this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostElectrical : "", "currency", "priceMyTradeReconditioningCostElectrical", true, false);
					electrical.hasChildren = true;
					group.addField(electrical);
					var grooming = new FieldModel("Grooming ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostGrooming ? this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostGrooming : "", "currency", "priceMyTradeReconditioningCostGrooming", true, false);
					grooming.hasChildren = true;
					group.addField(grooming);
					field_groups.push(group);

					group = new FieldGroupModel("Other costs");
					var other = new FieldModel("Other ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostOther ? this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostOther : "", "currency", "priceMyTradeReconditioningCostOther", true, false);
					other.hasChildren = true;
					group.addField(other);
					var roadUserChargesApply = new FieldModel('Road user charges apply', this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCApply, 'toggle', 'priceMyTradeRUCApply', true, false, null);
					roadUserChargesApply.hasChildren = true;
					group.addField(roadUserChargesApply);
					if (!this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCApply)
					{
						this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCDue = 0;
					}
					if (this.editActive || this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCApply)
					{
						var rucEnd = new FieldModel("RUC end (km)", this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCEndKm ? this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCEndKm : "", "number", "priceMyTradeRUCEndKm", true, true);
						rucEnd.parent = "priceMyTradeRUCApply";
						rucEnd.editable = this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCApply;
						rucEnd.toggleEditableWhen = "true";
						group.addField(rucEnd);

						var rucOwing = new FieldModel("Road user charges owing ($)", (this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCDue) ? this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCDue : "", "currency", "priceMyTradeRUCDue", true, false);
						rucOwing.parent = "priceMyTradeRUCApply";
						rucOwing.editable = this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCApply;
						rucOwing.toggleEditableWhen = "true";
						rucOwing.hasChildren = true;
						group.addField(rucOwing);
					}
					field_groups.push(group);

					group = new FieldGroupModel("Finance");
					var priceMyTradeFinanceIsOwing = new FieldModel('Finance is owing', this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceIsOwing, 'toggle', 'priceMyTradeFinanceIsOwing', true, false, null);
					priceMyTradeFinanceIsOwing.hasChildren = true;
					group.addField(priceMyTradeFinanceIsOwing);

					if (!this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceIsOwing)
					{
						this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmount = 0;
					}

					if (this.editActive || this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceIsOwing)
					{

						var priceMyTradeFinanceOwingAmount = new FieldModel("Finance amount owing ($)", (this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmount) ? this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmount : "", "currency", "priceMyTradeFinanceOwingAmount", true, true);
						priceMyTradeFinanceOwingAmount.parent = "priceMyTradeFinanceIsOwing";
						priceMyTradeFinanceOwingAmount.editable = this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceIsOwing;
						priceMyTradeFinanceOwingAmount.toggleEditableWhen = "true";
						priceMyTradeFinanceOwingAmount.hasChildren = true;
						group.addField(priceMyTradeFinanceOwingAmount);

						var priceMyTradeFinanceOwingAmountEstimated = new FieldModel('Finance amount is estimated', this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmountEstimated, 'toggle', 'priceMyTradeFinanceOwingAmountEstimated', true, false, null);
						priceMyTradeFinanceOwingAmountEstimated.parent = "priceMyTradeFinanceIsOwing";
						priceMyTradeFinanceOwingAmountEstimated.toggleEditableWhen = "true";
						group.addField(priceMyTradeFinanceOwingAmountEstimated);

						var financier = new FieldModel("Financier", this.editOpportunityActivity.priceMyTrade.priceMyTradeFinancier, "text", "priceMyTradeFinancier", true, true);
						financier.parent = "priceMyTradeFinanceIsOwing";
						financier.toggleEditableWhen = "true";
						financier.editable = this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceIsOwing;
						group.addField(financier);
					}
					field_groups.push(group);

					group = new FieldGroupModel("Appraiser comments");
					group.addField(new FieldModel("Notes for customer", this.editOpportunityActivity.priceMyTrade.priceMyTradeValuerComment, "longtext", "priceMyTradeValuerComment", true, false));
					group.addField(new FieldModel("Internal notes", this.editOpportunityActivity.priceMyTrade.priceMyTradeInternalComments, "longtext", "priceMyTradeInternalComments", true, false));
					field_groups.push(group);
				}
				else
				{
					group = new FieldGroupModel("Appraiser comments");
					group.addField(new FieldModel("Notes for customer", this.editOpportunityActivity.priceMyTrade.priceMyTradeValuerComment, "longtext", "priceMyTradeValuerComment", true, false));
					field_groups.push(group);
					group = new FieldGroupModel("Valuation");
					var valuationTotal = new FieldModel("Total valuation ($)", this.editOpportunityActivity.priceMyTrade.priceMyTradeValuation, "currency", "priceMyTradeValuation", true);
					group.addField(valuationTotal);
					field_groups.push(group);
				}

				if (this.checkMcMinVersion("3.1.33"))
				{
					group = new FieldGroupModel("Total estimate calculation");
					this.editOpportunityActivity.priceMyTrade.initialEstimateCopy = this.editOpportunityActivity.priceMyTrade.priceMyTradeInitialEstimate;
					var fieldInitialEstimateCopy = new FieldModel("Initial Estimate", this.editOpportunityActivity.priceMyTrade.initialEstimateCopy, "currency", "initialEstimateCopy", false);
					fieldInitialEstimateCopy.viewInEdit = true;
					fieldInitialEstimateCopy.calculationField = true;
					fieldInitialEstimateCopy.calculationOperator = "+";
					fieldInitialEstimateCopy.calculationFields = [
						"priceMyTradeInitialEstimate",
					];
					group.addField(fieldInitialEstimateCopy);
					this.editOpportunityActivity.priceMyTrade.totalReconditioning = this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostPaintAndPanel +
						this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostMechanical +
						this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostElectrical +
						this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostGrooming;
					var fieldTotalReconditioning = new FieldModel("Less Reconditioning", this.editOpportunityActivity.priceMyTrade.totalReconditioning, "currency", "totalReconditioning", false);
					fieldTotalReconditioning.viewInEdit = true;
					fieldTotalReconditioning.calculationField = true;
					fieldTotalReconditioning.calculationOperator = "+";
					fieldTotalReconditioning.calculationFields = [
						"priceMyTradeReconditioningCostPaintAndPanel",
						"priceMyTradeReconditioningCostMechanical",
						"priceMyTradeReconditioningCostElectrical",
						"priceMyTradeReconditioningCostGrooming",
					];
					group.addField(fieldTotalReconditioning);

					this.editOpportunityActivity.priceMyTrade.totalOther = this.editOpportunityActivity.priceMyTrade.priceMyTradeReconditioningCostOther + this.editOpportunityActivity.priceMyTrade.priceMyTradeRUCDue;
					var fieldTotalCosts = new FieldModel("Less Total Other & RUC", this.editOpportunityActivity.priceMyTrade.totalOther, "currency", "totalOther", false);
					fieldTotalCosts.viewInEdit = true;
					fieldTotalCosts.calculationField = true;
					fieldTotalCosts.calculationOperator = "+";
					fieldTotalCosts.calculationFields = [
						"priceMyTradeRUCDue",
						"priceMyTradeReconditioningCostOther",
					];
					group.addField(fieldTotalCosts);

					this.editOpportunityActivity.priceMyTrade.priceMyTradeValuation = this.editOpportunityActivity.priceMyTrade.priceMyTradeInitialEstimate -
						this.editOpportunityActivity.priceMyTrade.totalOther -
						this.editOpportunityActivity.priceMyTrade.totalReconditioning;
					var valuationTotal = new FieldModel("TOTAL ESTIMATE", this.editOpportunityActivity.priceMyTrade.priceMyTradeValuation, "currency", "priceMyTradeValuation", false);
					valuationTotal.viewInEdit = true;
					valuationTotal.calculationField = true;
					valuationTotal.calculationOperator = "-";
					valuationTotal.calculationFields = [
						"priceMyTradeInitialEstimate",
						"priceMyTradeReconditioningCostPaintAndPanel",
						"priceMyTradeReconditioningCostMechanical",
						"priceMyTradeReconditioningCostElectrical",
						"priceMyTradeReconditioningCostGrooming",
						"priceMyTradeRUCDue",
						"priceMyTradeReconditioningCostOther",
					];
					group.addField(valuationTotal);
					field_groups.push(group);

					group = new FieldGroupModel("Net value calculation");
					this.editOpportunityActivity.priceMyTrade.fieldFinanceOwingCopy = this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmount;
					var fieldFinanceOwingCopy = new FieldModel("Less encumbrance", this.editOpportunityActivity.priceMyTrade.fieldFinanceOwingCopy, "currency", "fieldFinanceOwingCopy", false);
					fieldFinanceOwingCopy.viewInEdit = true;
					fieldFinanceOwingCopy.calculationField = true;
					fieldFinanceOwingCopy.calculationOperator = "+";
					fieldFinanceOwingCopy.calculationFields = [
						"priceMyTradeFinanceOwingAmount",
					];
					group.addField(fieldFinanceOwingCopy);

					this.editOpportunityActivity.priceMyTrade.totalNet = this.editOpportunityActivity.priceMyTrade.priceMyTradeValuation - this.editOpportunityActivity.priceMyTrade.priceMyTradeFinanceOwingAmount;
					var valuationTotal = new FieldModel("NET VALUE", this.editOpportunityActivity.priceMyTrade.totalNet, "currency", "totalNet", false);
					valuationTotal.viewInEdit = true;
					valuationTotal.calculationField = true;
					valuationTotal.calculationOperator = "-";
					valuationTotal.calculationFields = [
						"priceMyTradeInitialEstimate",
						"priceMyTradeReconditioningCostPaintAndPanel",
						"priceMyTradeReconditioningCostMechanical",
						"priceMyTradeReconditioningCostElectrical",
						"priceMyTradeReconditioningCostGrooming",
						"priceMyTradeReconditioningCostOther",
						"priceMyTradeRUCDue",
						"priceMyTradeFinanceOwingAmount",
					];
					group.addField(valuationTotal);
					field_groups.push(group);
				}
				break;

			case "PriceMyTradeImages":
				group = new FieldGroupModel("Photos", null, "photo-adder-header");
				var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage1Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage1?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image = new FieldModel("Photo 1", resourceUrl, "photo", "PriceMyTradeImage1", true, false, null, "photo-adder");
				group.addField(image);
				var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage2Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage2?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image = new FieldModel("Photo 2", resourceUrl, "photo", "PriceMyTradeImage2", true, false, null, "photo-adder");
				group.addField(image);
				var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage3Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage3?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image = new FieldModel("Photo 3", resourceUrl, "photo", "PriceMyTradeImage3", true, false, null, "photo-adder");
				group.addField(image);
				var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage4Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage4?v=" + this.editOpportunityActivity.modifiedDate : "";
				var image = new FieldModel("Photo 4", resourceUrl, "photo", "PriceMyTradeImage4", true, false, null, "photo-adder");
				group.addField(image);
				if (this.checkMcMinVersion("3.1.33"))
				{
					var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage5Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage5?v=" + this.editOpportunityActivity.modifiedDate : "";
					var image = new FieldModel("Photo 5", resourceUrl, "photo", "PriceMyTradeImage5", true, false, null, "photo-adder");
					group.addField(image);
					var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage6Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage6?v=" + this.editOpportunityActivity.modifiedDate : "";
					var image = new FieldModel("Photo 6", resourceUrl, "photo", "PriceMyTradeImage6", true, false, null, "photo-adder");
					group.addField(image);
					var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage7Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage7?v=" + this.editOpportunityActivity.modifiedDate : "";
					var image = new FieldModel("Photo 7", resourceUrl, "photo", "PriceMyTradeImage7", true, false, null, "photo-adder");
					group.addField(image);
					var resourceUrl = (this.editOpportunityActivity.priceMyTrade.priceMyTradeImage8Exists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/PriceMyTradeImage8?v=" + this.editOpportunityActivity.modifiedDate : "";
					var image = new FieldModel("Photo 8", resourceUrl, "photo", "PriceMyTradeImage8", true, false, null, "photo-adder");
					group.addField(image);
				}
				field_groups.push(group);
				break;
			case OpportunityActivityType.VehicleWanted:
				group = new FieldGroupModel("Vehicle wanted details");
				group.addField(new FieldModel("Date & time", this.editOpportunityActivity.vehicleWanted.startDate, "datetime", "startDate", true, true));


				if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				{
					let makeLookup: LookupExternalModel = {
						collection: "VehicleManufacturer",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					var make = new FieldModel("Make", this.editOpportunityActivity.vehicleWanted.vehicleWantedMakeId, "lookup", "vehicleWantedMakeId", true, false, makeLookup);
					make.hasChildren = true;
					make.detailClass = VehicleClass.PassengerVehicle;
					group.addField(make);

					let modelLookup: LookupExternalModel = {
						collection: "VehicleModel",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					var model = new FieldModel("Model", this.editOpportunityActivity.vehicleWanted.vehicleWantedModelId, "lookup", "vehicleWantedModelId", true, false, modelLookup);
					model.parent = "vehicleWantedMakeId";
					model.detailClass = VehicleClass.PassengerVehicle;
					model.parentLookupId = this.editOpportunityActivity.vehicleWanted.vehicleWantedMake;
					model.hasChildren = true;
					group.addField(model);


					let variantLookup: LookupExternalModel = {
						collection: "VehicleVariant",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					var variant = new FieldModel("Variant", this.editOpportunityActivity.vehicleWanted.vehicleWantedVariantId, "lookup", "vehicleWantedVariantId", true, false, variantLookup);
					variant.parent = "vehicleWantedModelId";
					variant.detailClass = VehicleClass.PassengerVehicle;
					variant.parentLookupId = this.editOpportunityActivity.vehicleWanted.vehicleWantedModel;
					group.addField(variant);

					let bodyStyleLookup: LookupExternalModel = {
						collection: "VehicleBodyStyle",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					group.addField(new FieldModel("Body style", this.editOpportunityActivity.vehicleWanted.vehicleWantedBodyStyleId, "lookup", "vehicleWantedBodyStyleId", true, false, bodyStyleLookup));
				}
				else
				{
					///show the text fields
					group.addField(new FieldModel("Make", this.editOpportunityActivity.vehicleWanted.vehicleWantedMake, "text", "vehicleWantedMake", true, false));
					group.addField(new FieldModel("Model", this.editOpportunityActivity.vehicleWanted.vehicleWantedModel, "text", "vehicleWantedModel", true, false));
					group.addField(new FieldModel("Variant", this.editOpportunityActivity.vehicleWanted.vehicleWantedVariant, "text", "vehicleWantedVariant", true, false));
					group.addField(new FieldModel("Body style", this.editOpportunityActivity.vehicleWanted.vehicleWantedBodyStyle, "text", "vehicleWantedBodyStyle", true, false));

				}
				group.addField(new FieldModel("Year from", this.editOpportunityActivity.vehicleWanted.vehicleWantedYearFrom ? this.editOpportunityActivity.vehicleWanted.vehicleWantedYearFrom : "", "number", "vehicleWantedYearFrom", true, false));
				group.addField(new FieldModel("Year to", this.editOpportunityActivity.vehicleWanted.vehicleWantedYearTo ? this.editOpportunityActivity.vehicleWanted.vehicleWantedYearTo : "", "number", "vehicleWantedYearTo", true, false));

				if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				{
					let colourLookup: LookupExternalModel = {
						collection: "VehicleColorExterior",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};


					group.addField(new FieldModel("Colour", this.editOpportunityActivity.vehicleWanted.vehicleWantedColourId, "lookup", "vehicleWantedColourId", true, false, colourLookup));
				}
				else
				{
					group.addField(new FieldModel("Colour", this.editOpportunityActivity.vehicleWanted.vehicleWantedColour, "text", "vehicleWantedColour", true, false));
				}

				group.addField(new FieldModel("Seats", this.editOpportunityActivity.vehicleWanted.vehicleWantedSeatCount ? this.editOpportunityActivity.vehicleWanted.vehicleWantedSeatCount : "", "number", "vehicleWantedSeatCount", true, false));

				if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				{

					let transmissionLookup: LookupExternalModel = {
						collection: "VehicleTransmission",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					group.addField(new FieldModel("Transmission", this.editOpportunityActivity.vehicleWanted.vehicleWantedTransmissionId, "lookup", "vehicleWantedTransmissionId", true, false, transmissionLookup));

					let fuelTypeLookup: LookupExternalModel = {
						collection: "VehicleFuelType",
						lookupType: "External",
						lookupInternal: null,
						canAddNewValues: true,
						code: "",
						id: Constants.EmptyGuid,
						caption: "",
						parentId: Constants.EmptyGuid,
                        description: ""
					};

					group.addField(new FieldModel("Fuel type", this.editOpportunityActivity.vehicleWanted.vehicleWantedFuelTypeId, "lookup", "vehicleWantedFuelTypeId", true, false, fuelTypeLookup));

				}
				else
				{
					group.addField(new FieldModel("Transmission", this.editOpportunityActivity.vehicleWanted.vehicleWantedTransmission, "text", "vehicleWantedTransmission", true, false));
					group.addField(new FieldModel("Fuel type", this.editOpportunityActivity.vehicleWanted.vehicleWantedFuelType, "text", "vehicleWantedFuelType", true, false));
				}


				group.addField(new FieldModel("Engine size from (cc)", this.editOpportunityActivity.vehicleWanted.vehicleWantedEngineSizeFrom ? this.editOpportunityActivity.vehicleWanted.vehicleWantedEngineSizeFrom : "", "number", "vehicleWantedEngineSizeFrom", true, false));
				group.addField(new FieldModel("Engine size to (cc)", this.editOpportunityActivity.vehicleWanted.vehicleWantedEngineSizeTo ? this.editOpportunityActivity.vehicleWanted.vehicleWantedEngineSizeTo : "", "number", "vehicleWantedEngineSizeTo", true, false));
				group.addField(new FieldModel("Odometer from (km)", this.editOpportunityActivity.vehicleWanted.vehicleWantedOdoFrom ? this.editOpportunityActivity.vehicleWanted.vehicleWantedOdoFrom : "", "number", "vehicleWantedOdoFrom", true, false));
				group.addField(new FieldModel("Odometer to (km)", this.editOpportunityActivity.vehicleWanted.vehicleWantedOdoTo ? this.editOpportunityActivity.vehicleWanted.vehicleWantedOdoTo : "", "number", "vehicleWantedOdoTo", true, false));
				
                if (this.userService.mcMinVersion("3.2.22"))
                {
                    var priceFromObject = new PriceEditorModel();
                    priceFromObject.price = { id: "vehicleWantedPriceFrom", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFrom };
                    priceFromObject.taxType = { id: "vehicleWantedPriceFromTaxStatusEnum", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFromTaxStatusEnum };
                    priceFromObject.mode = "extended";
                    priceFromObject.removeTaxTypes = true;
                    priceFromObject.currency = { id: "vehicleWantedPriceFromCurrencyId", value: "" };
                    priceFromObject.taxRate = { id: "vehicleWantedPriceFromTaxRate", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFromTaxRate };
                    priceFromObject.taxAmount = { id: "vehicleWantedPriceFromTaxAmount", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFromTaxAmount };
                    var priceFrom = new FieldModel("Price from", this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFrom, "price", "orderAmount", true, false, priceFromObject);
                    priceFrom.allowZero = false;
                    group.addField(priceFrom);

                    var priceToObject = new PriceEditorModel();
                    priceToObject.price = { id: "vehicleWantedPriceTo", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceTo };
                    priceToObject.taxType = { id: "vehicleWantedPriceToTaxStatusEnum", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceToTaxStatusEnum };
                    priceToObject.mode = "extended";
                    priceToObject.removeTaxTypes = true;
                    priceToObject.currency = { id: "vehicleWantedPriceToCurrencyId", value: "" };
                    priceToObject.taxRate = { id: "vehicleWantedPriceToTaxRate", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceToTaxRate };
                    priceToObject.taxAmount = { id: "vehicleWantedPriceToTaxAmount", value: this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceToTaxAmount };
                    var priceTo = new FieldModel("Price to", this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceTo, "price", "orderAmount", true, false, priceToObject);
                    priceTo.allowZero = false;
                    group.addField(priceTo);
                }
                else
                {
                    var priceFromCaption = "Price from (" + this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFromTaxStatus.reference + ")";
                    group.addField(new FieldModel(priceFromCaption, this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFrom ? this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceFrom : "", "number", "vehicleWantedPriceFrom", true, false));
                    var priceToCaption = "Price to (" + this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceToTaxStatus.reference + ")";
                    group.addField(new FieldModel(priceToCaption, this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceTo ? this.editOpportunityActivity.vehicleWanted.vehicleWantedPriceTo : "", "number", "vehicleWantedPriceTo", true, false));
                }
                
				group.addField(new FieldModel("Comments", this.editOpportunityActivity.vehicleWanted.comment, "longtext", "comment", true, false));
				field_groups.push(group);
				break;
			case OpportunityActivityType.OutgoingEmail:

				group = new FieldGroupModel("Send details");
				var startDateTime = new FieldModel("Date & time sent", this.editOpportunityActivity.outgoingEmail.startDate, "datetime", "startDate", true, true);

				//If new activity
				if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				{
					if (this.editOpportunityActivity.customer.primaryEmail && this.validEmail(this.editOpportunityActivity.customer.primaryEmail))
					{
						var emailField = new FieldModel("Send email to customer?", this.editOpportunityActivity.outgoingEmail.sendCustomerEmail, "toggle", "sendCustomerEmail", true, false);
						// emailField.assistiveText = "Customer email address: " + this.editOpportunityActivity.customer.primaryEmail;
						emailField.hasChildren = true;
						group.addField(emailField);

						startDateTime.parent = "sendCustomerEmail";
						startDateTime.toggleEditableWhen = "false";

						if (this.userService.mcMinVersion("3.2.10") && this.emailAddresses.length > 0)
						{
							if (this.emailAddresses.length > 0)
							{
								this.editOpportunityActivity.outgoingEmail.replyTo = this.emailAddresses[this.emailAddresses.length - 1].id;
							};

							var to = new FieldModel("To", this.editOpportunityActivity.customer.primaryEmail, "text", "from", false, false, null, null, null, true);
							to.parent = "sendCustomerEmail";
							to.toggleVisibleWhen = "true";
							to.viewInEdit = false;
							group.addField(to);

							var replyTo = new FieldModel('Reply To', this.editOpportunityActivity.outgoingEmail.replyTo, 'select', 'replyTo', true, false, this.listEmailAddresses);
							replyTo.parent = "sendCustomerEmail";
							replyTo.toggleEditableWhen = "true";
							replyTo.editable = false;
							group.addField(replyTo);
						}
					}
				}
				group.addField(startDateTime);
				field_groups.push(group);

				group = new FieldGroupModel("Email details");
                group.singleColumn = true;
				group.addField(new FieldModel("Subject", this.editOpportunityActivity.outgoingEmail.subject, "text", "subject", true, true));
                if (editActive) {
                    group.addField(new FieldModel("Email Content", this.editOpportunityActivity.outgoingEmail.body, "longtext", "body", true, true));
                }
                else {
                    group.addField(new FieldModel("Email Content", this.editOpportunityActivity.outgoingEmail.body, "html", "body", true, true));
                }
				// if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				// {
				// 	this.editOpportunityActivity.outgoingEmail.emailIsSent = false;
				// 	var emailIsSentToggle = new FieldModel("Email was already sent", this.editOpportunityActivity.outgoingEmail.emailIsSent, "toggle", "emailIsSent", true, false);
				// 	emailIsSentToggle.hasChildren = true;
				// 	group.addField(emailIsSentToggle);
				// }
				field_groups.push(group);
				break;
			case OpportunityActivityType.IncomingEmail:
				group = new FieldGroupModel("Incoming email details");
				group.addField(new FieldModel("Date & time received", this.editOpportunityActivity.incomingEmail.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("Subject", this.editOpportunityActivity.incomingEmail.subject, "text", "subject", true, true));
				group.addField(new FieldModel("Email Content", this.editOpportunityActivity.incomingEmail.body, "longtext", "body", true, true));
				field_groups.push(group);
				break;
			case OpportunityActivityType.OutgoingSMS:
				group = new FieldGroupModel("Outgoing SMS details");

				group.addField(new FieldModel("Message", this.editOpportunityActivity.outgoingSMS.body, "longtext", "body", true, true));
				field_groups.push(group);

				if (this.editOpportunityActivity.id == Constants.EmptyGuid)
				{
					group = new FieldGroupModel("Details");
					if (this.editOpportunityActivity.customer.mobile && this.validPhone(this.editOpportunityActivity.customer.mobile))
					{
						var sendSmsField = new FieldModel("Send SMS to customer?", this.editOpportunityActivity.outgoingSMS.sendSMS, "toggle", "sendSMS", true, false);
						sendSmsField.assistiveText = "Customer mobile: " + this.editOpportunityActivity.customer.mobile;
						sendSmsField.hasChildren = true;
						group.addField(sendSmsField);
					}

					var startDateField = new FieldModel("Date & time sent", this.editOpportunityActivity.outgoingSMS.startDate, "datetime", "startDate", true, true);
					if (this.editOpportunityActivity.customer.mobile && this.validPhone(this.editOpportunityActivity.customer.mobile))
					{
						startDateField.parent = "sendSMS";
						startDateField.toggleEditableWhen = "false";
					}
					group.addField(startDateField);
					field_groups.push(group);
				}
				break;
			case OpportunityActivityType.IncomingSMS:
				group = new FieldGroupModel("Incoming SMS details");
				group.addField(new FieldModel("Date & time received", this.editOpportunityActivity.incomingSMS.startDate, "datetime", "startDate", true, true));
				group.addField(new FieldModel("Message", this.editOpportunityActivity.incomingSMS.body, "longtext", "body", true, true));
				field_groups.push(group);
				break;
			case OpportunityActivityType.FinanceApp:
				// group = new FieldGroupModel("Finance Application");

				// var tradeInTotal = new FieldModel("Vehicle Price", this.editOpportunityActivity.financeApplication.summaryPurchaseAmount, "currency", "summaryPurchaseAmount", false);
				// tradeInTotal.viewInEdit = true;
				// tradeInTotal.calculationField = true;
				// field_groups.push(group);

				if (this.editOpportunityActivity.vehicle)
				{
					group = new FieldGroupModel("Sale Vehicle");
					var vehiclePriceVal = (this.editOpportunityActivity.vehicle) ? this.editOpportunityActivity.vehicle.effectivePriceAmount : 0;
					if (!this.editOpportunityActivity.financeApplication.vehicleSalePrice && this.editOpportunityActivity.vehicle)
					{
						this.editOpportunityActivity.financeApplication.vehicleSalePrice = this.editOpportunityActivity.vehicle.effectivePriceAmount;
					}
					var vehiclePrice = new FieldModel("Vehicle sale price", this.editOpportunityActivity.financeApplication.vehicleSalePrice, "currency", "vehicleSalePrice", true, false);
					vehiclePrice.hasChildren = true;
					group.addField(vehiclePrice);
					field_groups.push(group);
				}

				group = new FieldGroupModel("Trade In");

				var tradeInValue = new FieldModel("Value of trade ins", this.editOpportunityActivity.financeApplication.tradeInValue, "currency", "tradeInValue", true, false);
				tradeInValue.hasChildren = true;
				group.addField(tradeInValue);

				var tradeInEncumbrance = new FieldModel("Encumbrance", this.editOpportunityActivity.financeApplication.tradeInEncumbranceValue, "currency", "tradeInEncumbranceValue", true, false);
				tradeInEncumbrance.hasChildren = true;
				group.addField(tradeInEncumbrance);

				this.editOpportunityActivity.financeApplication.summarySaleNetTradeInsAmount = this.editOpportunityActivity.financeApplication.tradeInValue - this.editOpportunityActivity.financeApplication.tradeInEncumbranceValue;
				var tradeInTotal = new FieldModel("Net trade ins", this.editOpportunityActivity.financeApplication.summarySaleNetTradeInsAmount, "currency", "summarySaleNetTradeInsAmount", false);
				tradeInTotal.hasChildren = true;
				tradeInTotal.viewInEdit = true;
				tradeInTotal.calculationField = true;
				tradeInTotal.calculationOperator = "-";
				tradeInTotal.calculationFields = [
					"tradeInValue",
					"tradeInEncumbranceValue",
				];
				group.addField(tradeInTotal);

				field_groups.push(group);

				group = new FieldGroupModel("Cash Deposits");
				var depositOnSigning = new FieldModel("Deposit on signing", this.editOpportunityActivity.financeApplication.paymentDepositOnSigningAmount, "currency", "paymentDepositOnSigningAmount", true, false);
				depositOnSigning.hasChildren = true;
				group.addField(depositOnSigning);

				var paymentDueOnDelivery = new FieldModel("Payment due on delivery", this.editOpportunityActivity.financeApplication.paymentDueOnDeliveryAmount, "currency", "paymentDueOnDeliveryAmount", true, false);
				paymentDueOnDelivery.hasChildren = true;
				group.addField(paymentDueOnDelivery);

				var cashDepositsTotalVal = this.editOpportunityActivity.financeApplication.paymentDepositOnSigningAmount + this.editOpportunityActivity.financeApplication.paymentDueOnDeliveryAmount;
				var cashDepositsTotal = new FieldModel("Cash deposits total", cashDepositsTotalVal, "currency", "summaryBalanceCashInstallments", false);
				cashDepositsTotal.viewInEdit = true;
				cashDepositsTotal.calculationField = true;
				cashDepositsTotal.calculationOperator = "+";
				cashDepositsTotal.calculationFields = [
					"paymentDepositOnSigningAmount",
					"paymentDueOnDeliveryAmount",
				];
				group.addField(cashDepositsTotal);

				if (this.editActive)
				{
					if (!this.editOpportunityActivity.financeApplication.amountToFinance)
					{
						this.editOpportunityActivity.financeApplication.amountToFinance =
							this.editOpportunityActivity.financeApplication.vehicleSalePrice -
							this.editOpportunityActivity.financeApplication.summarySaleNetTradeInsAmount -
							this.editOpportunityActivity.financeApplication.paymentDepositOnSigningAmount -
							this.editOpportunityActivity.financeApplication.paymentDueOnDeliveryAmount;
					}
					var amountToFinance = new FieldModel("Amount to finance", this.editOpportunityActivity.financeApplication.amountToFinance, "currency", "amountToFinance", (!this.editOpportunityActivity.vehicle));
					amountToFinance.viewInEdit = true;
					amountToFinance.calculationField = true;
					amountToFinance.calculationOperator = "-";
					amountToFinance.calculationFields = [
						"vehicleSalePrice",
						"summarySaleNetTradeInsAmount",
						"paymentDepositOnSigningAmount",
						"paymentDueOnDeliveryAmount",
					];
					group.addField(amountToFinance);

				}
				else
				{

					field_groups.push(group);
					group = new FieldGroupModel("");
					group.addField(new FieldModel("Amount to Finance", this.editOpportunityActivity.financeApplication.amountToFinance, "currency", "amountToFinance", true, false));
				}

				if (this.editOpportunityActivity.financeApplication.financeApplicationURL)
				{
					field_groups.push(group);
					group = new FieldGroupModel("");
					group.addField(new FieldModel("Finance Application URL", this.editOpportunityActivity.financeApplication.financeApplicationURL, "url", "financeApplicationURL", true, false));
				}
				field_groups.push(group);
				break;


            case OpportunityActivityType.LoanVehicle:
                group = new FieldGroupModel("Loan vehicle Details");
                group.addField(new FieldModel("Start date & time", this.editOpportunityActivity.loanVehicle.startDate, "datetime", "startDate", true, true));
                group.addField(new FieldModel("End date & time", this.editOpportunityActivity.loanVehicle.endDate, "datetime", "endDate", true, true));
                group.addField(new FieldModel("Comments", this.editOpportunityActivity.loanVehicle.comment, "longtext", "comment", true, false));
                // group.addField(new FieldModel("Accompanied by salesperson", this.editOpportunityActivity.loanVehicle.loanVehicleAccompanied, 'toggle', 'loanVehicleAccompanied', true, false));

                if (this.editOpportunityActivity.id != Constants.EmptyGuid)
                {
                    group.addField(new FieldModel('Loan vehicle complete & vehicle returned', this.editOpportunityActivity.loanVehicle.loanVehicleComplete, 'toggle', 'loanVehicleComplete', true, false, null));
                    var loanVehicleCompleteTimestamp = this.getFormattedDateTime(this.editOpportunityActivity.loanVehicle.loanVehicleCompleteTimestamp);

                    if (this.editOpportunityActivity.loanVehicle.loanVehicleComplete && loanVehicleCompleteTimestamp)
                    {
                        group.addField(new FieldModel("Loan vehicle completed time", loanVehicleCompleteTimestamp, "text", "loanVehicleCompleteTimestamp", false, false, null, null, null, true));
                    }
                }

                var dealerPlateLookup = new FieldModel("Dealer Plate", this.editOpportunityActivity.loanVehicle.loanVehicleDealerPlateId, "lookup", "loanVehicleDealerPlateId", true, false, this.editOpportunityActivity.loanVehicle.loanVehicleDealerPlate);
                dealerPlateLookup.allowClear = true;
                group.addField(dealerPlateLookup);

                if (this.userService.mcMinVersion("3.2.22"))
                {
                    var purposeOfUse = new FieldModel("Purpose of use", this.editOpportunityActivity.loanVehicle.loanVehiclePurposeOfUseId, "lookup", "loanVehiclePurposeOfUseId", true, false, this.editOpportunityActivity.loanVehicle.loanVehiclePurposeOfUse);
                    purposeOfUse.allowClear = true;
                    group.addField(purposeOfUse);

                    var fuelLevelAtPickup = new FieldModel("Fuel level at pickup", this.editOpportunityActivity.loanVehicle.loanVehicleFuelLevelAtPickupId, "lookup", "loanVehicleFuelLevelAtPickupId", true, false, this.editOpportunityActivity.loanVehicle.loanVehicleFuelLevelAtPickup);
                    fuelLevelAtPickup.allowClear = true;
                    group.addField(fuelLevelAtPickup);

                    group.addField(new FieldModel("Odometer start (km)", this.editOpportunityActivity.loanVehicle.loanVehicleOdometerStart, 'number', 'loanVehicleOdometerStart', true, false));
                    group.addField(new FieldModel("Odometer finish (km)", this.editOpportunityActivity.loanVehicle.loanVehicleOdometerFinish, 'number', 'loanVehicleOdometerFinish', true, false));
                }
           
                field_groups.push(group);
                break;
            case "LoanVehicleLicence":
                group = new FieldGroupModel("Driver licence");
                var resourceUrl = (this.editOpportunityActivity.loanVehicle.driverLicenceImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/LoanVehicleDriverLicence?v=" + this.editOpportunityActivity.modifiedDate : "";
                var image = new FieldModel("Driver licence front", resourceUrl, "photo", "LoanVehicleDriverLicence", true, false);
                group.addField(image);

                var resourceUrl2 = (this.editOpportunityActivity.loanVehicle.driverLicenceBackImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/LoanVehicleDriverLicenceBack?v=" + this.editOpportunityActivity.modifiedDate : "";
                var image2 = new FieldModel("Driver licence back", resourceUrl2, "photo", "LoanVehicleDriverLicenceBack", true, false);
                group.addField(image2);
                field_groups.push(group);
                break;
            case "LoanVehicleTerms":
                if (this.editOpportunityActivity.signingRequest)
                {
                    group = new FieldGroupModel("Terms agreement");
                    var status = new FieldModel("Digital signing status", this.editOpportunityActivity.signingRequest.workflowStatus, "inlinehtml", "workflowStatus", false, false);
                    group.addField(status);
                    var details = this.editOpportunityActivity.signingRequest.description.replace(";", "<br/>").replace("Resent", "Resent:").replace("Sent", "Sent:");
                    details += `<br/><br/>To: ${this.editOpportunityActivity.signingRequest.recipientContact.displayName} &lt;${this.editOpportunityActivity.signingRequest.recipientContact.primaryEmail}&gt;`;
                    details += `<br/>From: ${this.editOpportunityActivity.signingRequest.senderContact.displayName} (${this.editOpportunityActivity.signingRequest.senderCompany.displayName}) &lt;${this.editOpportunityActivity.signingRequest.senderCompany.primaryEmail}&gt;`;
                    group.addField(new FieldModel("Details", details, "inlinehtml", "caption", false, false));

                    field_groups.push(group);
                }
                else
                {
                    group = new FieldGroupModel("Terms agreement");
                    if (this.editOpportunityActivity.customer && this.editOpportunityActivity.customer.id != Constants.EmptyGuid)
                    {
                        this.editOpportunityActivity.loanVehicle.loanVehicleTerms = this.editOpportunityActivity.loanVehicle.loanVehicleTerms.replace("{{CustomerName}}", this.editOpportunityActivity.customer.displayName);
                    }

                    if (!isExpress)
                    {
                        group.addField(new FieldModel("Terms", "" + this.editOpportunityActivity.loanVehicle.loanVehicleTerms + "", "inlinehtml", "loanVehicleTerms", false, false, null, null, null, true));
                        
                        group.addField(new FieldModel("Yes, I agree to these terms", this.editOpportunityActivity.loanVehicle.acceptTerms, "toggle", "acceptTerms", true, false));
                    }
                    var resourceUrl = (this.editOpportunityActivity.loanVehicle.signatureImageExists) ? Constants.ApiUrl + "Activities/" + this.editOpportunityActivity.id + "/Images/LoanVehicleSignature" : "";
                    var signature = new FieldModel("Loan vehicle signature", resourceUrl, "signature", "LoanVehicleSignature", true, false);
                    signature.showPlaceholder = (!this.editOpportunityActivity.loanVehicle.signatureImageExists);
                    group.addField(signature);

                    if (this.userService.mcMinVersion("3.1.33") && this.editOpportunityActivity.loanVehicle.loanVehicleSignatureName)
                    {
                        var signedBy = new FieldModel("Signed By name", this.editOpportunityActivity.loanVehicle.loanVehicleSignatureName, "text", "loanVehicleSignatureName", true, false);
                        group.addField(signedBy);
                        group.addField(new FieldModel("Signed By date", this.editOpportunityActivity.loanVehicle.loanVehicleSignatureTimestamp, "datetime", "subject", false, false));
                    }

                    field_groups.push(group);
                }
                break;
            case OpportunityActivityType.Sale:

                if (this.editOpportunityActivity.vehicle)
                {
                    group = new FieldGroupModel("Sale Vehicle");
                    var vehiclePriceVal = (this.editOpportunityActivity.vehicle) ? this.editOpportunityActivity.vehicle.effectivePriceAmount : 0;
                    if (!this.editOpportunityActivity.sale.vehicleSalePrice && this.editOpportunityActivity.vehicle)
                    {
                        this.editOpportunityActivity.sale.vehicleSalePrice = this.editOpportunityActivity.vehicle.effectivePriceAmount;
                    }
                    var vehiclePrice = new FieldModel("Vehicle sale price", this.editOpportunityActivity.sale.vehicleSalePrice, "currency", "vehicleSalePrice", true, false);
                    vehiclePrice.hasChildren = true;
                    group.addField(vehiclePrice);
                    field_groups.push(group);
                }
                else
                {
                    this.editOpportunityActivity.vehicleId = Constants.EmptyGuid;
                }

                group = new FieldGroupModel("Trade In");

                var tradeInValue = new FieldModel("Value of trade ins", this.editOpportunityActivity.sale.tradeInValue, "currency", "tradeInValue", true, false);
                tradeInValue.hasChildren = true;
                group.addField(tradeInValue);

                var tradeInEncumbrance = new FieldModel("Encumbrance", this.editOpportunityActivity.sale.tradeInEncumbranceValue, "currency", "tradeInEncumbranceValue", true, false);
                tradeInEncumbrance.hasChildren = true;
                group.addField(tradeInEncumbrance);

                this.editOpportunityActivity.sale.summarySaleNetTradeInsAmount = this.editOpportunityActivity.sale.tradeInValue - this.editOpportunityActivity.sale.tradeInEncumbranceValue;
                var tradeInTotal = new FieldModel("Net trade ins", this.editOpportunityActivity.sale.summarySaleNetTradeInsAmount, "currency", "summarySaleNetTradeInsAmount", false);
                tradeInTotal.hasChildren = true;
                tradeInTotal.viewInEdit = true;
                tradeInTotal.calculationField = true;
                tradeInTotal.calculationOperator = "-";
                tradeInTotal.calculationFields = [
                    "tradeInValue",
                    "tradeInEncumbranceValue",
                ];
                group.addField(tradeInTotal);

                field_groups.push(group);

                group = new FieldGroupModel("Cash Deposits");
                var depositOnSigning = new FieldModel("Deposit on signing", this.editOpportunityActivity.sale.paymentDepositOnSigningAmount, "currency", "paymentDepositOnSigningAmount", true, false);
                depositOnSigning.hasChildren = true;
                group.addField(depositOnSigning);

                var paymentDueOnDelivery = new FieldModel("Payment due on delivery", this.editOpportunityActivity.sale.paymentDueOnDeliveryAmount, "currency", "paymentDueOnDeliveryAmount", true, false);
                paymentDueOnDelivery.hasChildren = true;
                group.addField(paymentDueOnDelivery);

                var cashDepositsTotalVal = this.editOpportunityActivity.sale.paymentDepositOnSigningAmount + this.editOpportunityActivity.sale.paymentDueOnDeliveryAmount;
                var cashDepositsTotal = new FieldModel("Cash deposits total", cashDepositsTotalVal, "currency", "summaryBalanceCashInstallments", false);
                cashDepositsTotal.viewInEdit = true;
                cashDepositsTotal.calculationField = true;
                cashDepositsTotal.calculationOperator = "+";
                cashDepositsTotal.calculationFields = [
                    "paymentDepositOnSigningAmount",
                    "paymentDueOnDeliveryAmount",
                ];
                group.addField(cashDepositsTotal);
                field_groups.push(group);
                break;
            case OpportunityActivityType.Quote:
                if (this.editOpportunityActivity.vehicle)
                {
                    group = new FieldGroupModel("Quote Vehicle");
                    var vehiclePriceVal = (this.editOpportunityActivity.vehicle) ? this.editOpportunityActivity.vehicle.effectivePriceAmount : 0;
                    if (!this.editOpportunityActivity.quote.vehicleSalePrice && this.editOpportunityActivity.vehicle)
                    {
                        this.editOpportunityActivity.quote.vehicleSalePrice = this.editOpportunityActivity.vehicle.effectivePriceAmount;
                    }
                    var vehiclePrice = new FieldModel("Vehicle sale price", this.editOpportunityActivity.quote.vehicleSalePrice, "currency", "vehicleSalePrice", true, false);
                    vehiclePrice.hasChildren = true;
                    group.addField(vehiclePrice);
                    field_groups.push(group);
                }
                else
                {
                    this.editOpportunityActivity.vehicleId = Constants.EmptyGuid;
                }
                
                group = new FieldGroupModel("Trade In");

                var tradeInValue = new FieldModel("Value of trade ins", this.editOpportunityActivity.quote.tradeInValue, "currency", "tradeInValue", true, false);
                tradeInValue.hasChildren = true;
                group.addField(tradeInValue);

                var tradeInEncumbrance = new FieldModel("Encumbrance", this.editOpportunityActivity.quote.tradeInEncumbranceValue, "currency", "tradeInEncumbranceValue", true, false);
                tradeInEncumbrance.hasChildren = true;
                group.addField(tradeInEncumbrance);

                this.editOpportunityActivity.quote.summarySaleNetTradeInsAmount = this.editOpportunityActivity.quote.tradeInValue - this.editOpportunityActivity.quote.tradeInEncumbranceValue;
                var tradeInTotal = new FieldModel("Net trade ins", this.editOpportunityActivity.quote.summarySaleNetTradeInsAmount, "currency", "summarySaleNetTradeInsAmount", false);
                tradeInTotal.hasChildren = true;
                tradeInTotal.viewInEdit = true;
                tradeInTotal.calculationField = true;
                tradeInTotal.calculationOperator = "-";
                tradeInTotal.calculationFields = [
                    "tradeInValue",
                    "tradeInEncumbranceValue",
                ];
                group.addField(tradeInTotal);

                field_groups.push(group);
                
                group = new FieldGroupModel("Cash Deposits");
                var depositOnSigning = new FieldModel("Deposit on signing", this.editOpportunityActivity.quote.paymentDepositOnSigningAmount, "currency", "paymentDepositOnSigningAmount", true, false);
                depositOnSigning.hasChildren = true;
                group.addField(depositOnSigning);

                var paymentDueOnDelivery = new FieldModel("Payment due on delivery", this.editOpportunityActivity.quote.paymentDueOnDeliveryAmount, "currency", "paymentDueOnDeliveryAmount", true, false);
                paymentDueOnDelivery.hasChildren = true;
                group.addField(paymentDueOnDelivery);

                var cashDepositsTotalVal = this.editOpportunityActivity.quote.paymentDepositOnSigningAmount + this.editOpportunityActivity.quote.paymentDueOnDeliveryAmount;
                var cashDepositsTotal = new FieldModel("Cash deposits total", cashDepositsTotalVal, "currency", "summaryBalanceCashInstallments", false);
                cashDepositsTotal.viewInEdit = true;
                cashDepositsTotal.calculationField = true;
                cashDepositsTotal.calculationOperator = "+";
                cashDepositsTotal.calculationFields = [
                    "paymentDepositOnSigningAmount",
                    "paymentDueOnDeliveryAmount",
                ];
                group.addField(cashDepositsTotal);
                field_groups.push(group);
                break;

		}
		return field_groups;
	}

	public validEmail(email: string): boolean
	{
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	}

	public validPhone(phone: string): boolean
	{
		var phoneNumber = parsePhoneNumberFromString(phone, "NZ");
		if (phoneNumber && phoneNumber.isValid())
		{
			return true;
		}
	}

	checkMcMinVersion(subversion: string): boolean
	{
		return this.userService.mcMinVersion(subversion);
	}

	public getFormattedDateTime(date: Date)
	{
		return DateHelper.getFormattedDateTime(date);
	}

	getFileToken(id: string): Observable<string>
	{
		let httpParams = new HttpParams();
		var url = Constants.ApiUrl + "Activities/" + id + "/Enquiry";
		return this.httpClient.get<string>(url, { params: httpParams });
	}

	getActivityPdf(id: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(Constants.ApiUrl + 'Activities/' + id + "/pdf", { params: httpParams, responseType: "blob" });
	}
	getActivityPdfUrl(id: string): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<LabelValueModel>(Constants.ApiUrl + 'Activities/' + id + "/url", { params: httpParams });
	}
	getFinanceApplicationPdf(id: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(Constants.ApiUrl + 'Activities/finance-application/' + id + "/pdf", { params: httpParams, responseType: "blob" });
	}
	getFinanceApplicationPdfUrl(id: string): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<LabelValueModel>(Constants.ApiUrl + 'Activities/finance-application/' + id + "/url", { params: httpParams });
	}
	getFinanceCalculatorPdf(id: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(Constants.ApiUrl + 'Activities/finance-calculator/' + id + "/pdf", { params: httpParams, responseType: "blob" });
	}
	getFinanceCalculatorPdfUrl(id: string): Observable<LabelValueModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<LabelValueModel>(Constants.ApiUrl + 'Activities/finance-calculator/' + id + "/url", { params: httpParams });
	}
	getExternalPdf(url: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get(url, { params: httpParams, responseType: "blob" });
	}

	emailAddresses: EmailAddress[];
	listEmailAddresses: ListItemModel[];

	public async getEmailAddresses(): Promise<void>
	{
		if (this.userService.mcMinVersion("3.2.10"))
		{
			const emailAddresses = await this.getCachedEmailAddresses().toPromise();
			this.emailAddresses = emailAddresses;
			this.listEmailAddresses = emailAddresses.map<ListItemModel>(y => new ListItemModel(y.id, y.emailAddress));
		}
	}
	public getCachedEmailAddresses(): Observable<EmailAddress[]>
	{
		return this.contactService.getCachedEmailAddresses();
	}

	public getOpportunityDocuments(id: string): Observable<DocumentModel[]>
	{
		return this.httpClient.get<DocumentModel[]>(Constants.ApiUrl + 'Opportunities/' + id + "/Documents");
	}

	public getOpportunityDocument(id: string, documentURI: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get(Constants.ApiUrl + 'Opportunities/' + id + "/Document", { params: httpParams, responseType: "blob" });
	}

	public getOpportunityDocumentUrl(id: string, documentURI: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get<string>(Constants.ApiUrl + 'Opportunities/' + id + "/DocumentUrl", { params: httpParams });
	}

	public uploadDocuments(id: string, files: Blob[], title: string, documentCategory: string, uploadDocumentName: string[]): Observable<any>
	{
		let url = Constants.ApiUrl + 'opportunities/' + id + '/document/new';

		const formData = new FormData();
		for (var i = 0; i < files.length; i++)
		{
			formData.append('document', files[i]);
			formData.append('title', title);
			formData.append('documentCategory', documentCategory);
			formData.append('uploadDocumentName', uploadDocumentName[i]);
		}
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });

	}

	public updateDocument(id: string, documentUri: string, fileDesc: string, fileCategory: number): Observable<SingleDocumentUploadModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', id);
		httpParams = httpParams.append('documentUri', documentUri);
		httpParams = httpParams.append('fileDesc', fileDesc);
		httpParams = httpParams.append('fileCategory', fileCategory);
		return this.httpClient.patch<SingleDocumentUploadModel>(Constants.ApiUrl + 'opportunities/' + id + '/document/update', httpParams);
	}

	public deleteDocument(id: string, documentUri: string): Observable<Array<DocumentModel>>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', id);
		httpParams = httpParams.append('documentUri', documentUri);

		return this.httpClient.delete<Array<DocumentModel>>(Constants.ApiUrl + 'opportunities/' + id + '/document/delete', { params: httpParams });
	}


	getOpportunityAppraisalActivityVehicles(id: string): Observable<OpportunityActivityModel>
	{

		return this.httpClient.get<OpportunityActivityModel>(Constants.ApiUrl + `opportunities/${id}/appraisal-vehicles`);
	}


	//this.opportunity_id, this.chosenCustomersRelatedToSale, this.chosenVehiclesToSell, this.chosenVehiclesToBuy, this.depositAmount
	public convertOpportunityToSale(id: string, saleCreationDetails: OpportunitySaleCreateModel): Observable<string>
	{
		return this.httpClient.post<string>(Constants.ApiUrl + `opportunities/${id}/sale`, saleCreationDetails);
	}

	public getOpportunityByCustomerId(contactId: string): Observable<string>
	{
		return this.httpClient.get<string>(Constants.ApiUrl + `opportunities/customer/${contactId}`);
	}

    public addQuickResponseActivity(opportunityId: string, quickResponse: OpportunityQuickResponseModel): Observable<OpportunityModel>
	{
		return this.httpClient.post<OpportunityModel>(Constants.ApiUrl + `opportunities/${opportunityId}/quickResponse`, quickResponse);
	}

    public convertOpportunityActivity(opportunityId: string, activityId: string, activityType: OpportunityActivityType): Observable<OpportunityActivityModel>
	{
		return this.httpClient.get<OpportunityActivityModel>(Constants.ApiUrl + `Opportunities/${opportunityId}/Activity/${activityId}/activityType/${activityType}/convert`);
	}

    public deleteOpportunityActivity(opportunityId: string, activityId: string): Observable<boolean>
    {
        return this.httpClient.delete<boolean>(Constants.ApiUrl + `Activities/${activityId}`);
    }

    public transferOpportunity(opportunityTransferPayload: OpportunityTransferModel): Observable<string>
    {
        return this.httpClient.patch<string>(Constants.ApiUrl + `Opportunities/${opportunityTransferPayload.openOpportunityId}/transfer`, opportunityTransferPayload);
    }

}
